import { CheckIcon } from "@chakra-ui/icons";
import {
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
} from "@chakra-ui/input";
import React from "react";
import {
  BaseFieldProps,
  FieldWrapper,
} from "../fields/FieldWrapper/FieldWrapper";

interface TimeFieldProps extends BaseFieldProps {
  isValid?: boolean;
}

export const TimeField = ({
  name,
  label,
  id,
  helperText,
  isValid,
  infoText,
  ...inputProps
}: TimeFieldProps & InputProps) => {
  const formatTime = (timeStr: string): string => {
    const [h, m] = timeStr?.split(":") ?? [];
    return h && m ? `${h.padStart(2, "0")}:${m.padStart(2, "0")}` : "";
  };

  return (
    <FieldWrapper
      name={name}
      id={id}
      label={label}
      helperText={helperText}
      infoText={infoText}
    >
      {({ field, form }) => (
        <InputGroup backgroundColor="#fff" shadow="sm">
          <Input
            {...field}
            value={field.value == null ? "" : formatTime(field.value)}
            {...inputProps}
            type="time"
            step="1"
            onChange={(e) => {
              const value = e.target.value;
              form.setFieldValue(name, value ? `${value}` : "");
            }}
          />
          {isValid && (
            <InputRightElement children={<CheckIcon color="green.400" />} />
          )}
        </InputGroup>
      )}
    </FieldWrapper>
  );
};
